import { render, staticRenderFns } from "./RegisteredTypeForm.vue?vue&type=template&id=73dd7fbe&scoped=true&"
import script from "./RegisteredTypeForm.vue?vue&type=script&lang=js&"
export * from "./RegisteredTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dd7fbe",
  null
  
)

export default component.exports